import { render, staticRenderFns } from "./AddressLookup.vue?vue&type=template&id=0f8921ea&scoped=true"
import script from "./AddressLookup.vue?vue&type=script&lang=js"
export * from "./AddressLookup.vue?vue&type=script&lang=js"
import style0 from "./AddressLookup.vue?vue&type=style&index=0&id=0f8921ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8921ea",
  null
  
)

export default component.exports